/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-console */
import { useEffect } from 'react';

interface DeckeeWindow extends Window {
  DECKEE_CONFIG?: {
    oneSignalAppID?: string;
  };
}

declare const window: DeckeeWindow;
import OneSignalPlugin from 'onesignal-cordova-plugin';
import { Capacitor } from '@capacitor/core';
import { useHistory } from 'react-router-dom';
import { transitionToNextRoute } from '../../../services/route/route-navigation';

const OneSignal = OneSignalPlugin;

export function useOneSignalSetup(currentMember: {
  id?: string | number | undefined;
  isOnBoardingComplete: boolean | undefined;
}) {
  const { id: currentMemberId, isOnBoardingComplete } = currentMember || {};
  const history = useHistory();
  const isNative = Capacitor.isNativePlatform();
  useEffect(() => {
    // @ts-ignore
    if (OneSignal.initialize && OneSignal.Notifications && isNative) {
      OneSignal.Notifications.addEventListener('click', async (event) => {
        // @ts-ignore
        const route = event?.notification?.additionalData?.route;
        // @ts-ignore
        const routeParams = event?.notification?.additionalData?.routeParams;

        if (route) {
          if (route.split('/').length > 1) {
            history.push(route);
          }

          if (routeParams) {
            transitionToNextRoute(route, routeParams);
          } else {
            transitionToNextRoute(route);
          }
        }
      });
    }
  }, [history, isNative]);

  useEffect(() => {
    if (!currentMemberId) return; // Do nothing if user is not logged in

    if (window?.DECKEE_CONFIG?.oneSignalAppID && Capacitor.isNativePlatform()) {
      const oneSignalAppID = window?.DECKEE_CONFIG?.oneSignalAppID;
      const setupOneSignal = async () => {
        // Check version as old app builds using capacitor 5 versions (ie. Deckee app versions 4 and below) shouldn't run this
        const { version }: { version: string } =
          await Capacitor.Plugins.App.getInfo();
        const majorVersion = version.match(/^(\d+)\..*$/)?.[1];

        if (majorVersion && parseInt(majorVersion, 10) >= 4) {
          try {
            console.log('Initializing OneSignal...');

            await OneSignal.logout();
            await OneSignal.initialize(oneSignalAppID);
            await OneSignal.login(currentMemberId.toString());

            console.log('OneSignal Initialized');

            // Check if user has already subscribed
            const subscription = await OneSignal.User.pushSubscription;
            console.log('Current Subscription Status:', subscription);

            if (!subscription.optedIn) {
              console.log('Opting in to push notifications...');
              await OneSignal.User.pushSubscription.optIn(); // Opt-in to push notifications
            }

            if (!subscription.token) {
              console.log('Requesting push notification permissions...');
              await OneSignal.Notifications.requestPermission(); // Request notification permissions
            }

            // Set external user ID (add alias)
            console.log(`Setting external user ID: ${currentMemberId}`);
            await OneSignal.User.addAlias('external_id', `${currentMemberId}`);

            console.log('OneSignal setup complete!');
          } catch (error) {
            console.error('Error setting up OneSignal:', error);
          }
        }
      };

      if (isOnBoardingComplete) {
        setupOneSignal();
      }
    }
  }, [currentMemberId, isOnBoardingComplete]); // Runs when currentMemberId changes
}
